import { Typography, type TypographyProps } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	amount: string;
	variant: TypographyProps["variant"];
	color?: string;
	suffixVariant: TypographyProps["variant"];
	suffixColor: string;
	suffixWeight?: number;
};

export const AmountWithCurrency: FC<Props> = ({
	amount,
	variant,
	color,
	suffixVariant,
	suffixColor,
	suffixWeight,
}) => {
	const { t } = useResource();

	return (
		<Typography variant={variant} color={color} tabular>
			{amount}{" "}
			<Typography
				component="span"
				variant={suffixVariant}
				fontWeight={suffixWeight}
				color={suffixColor}
			>
				{t(Resources.Common.CurrencySign)}
			</Typography>
		</Typography>
	);
};
